import React from 'react';
import PropTypes from 'prop-types';
import { PasswordReset } from 'react-cognito';
import Button from '../Button';
import Link from '../Link';
import { Form, Input } from '../Form';
import { Brandmark } from '../Icons';
import Style from '../Style';
import { H3, L2, P1, P2 } from '../Typography';

class ResetPasswordForm extends React.PureComponent {
  static propTypes = {
    error: PropTypes.string,
    username: PropTypes.string,
    setPassword: PropTypes.func,
    onAfterSetPassword: PropTypes.func,
  };
  static defaultProps = {
    onAfterSetPassword: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      formEnabled: true,
      email: '',
      code: '',
      password: '',
      message: '',
      error: '',
    };
  }

  onSubmit = () => {
    if (!this.state.formEnabled) {
      return;
    }

    this.setState({ formEnabled: false, fetching: true, error: '' });
    this.props
      .setPassword(this.state.email, this.state.code, this.state.password)
      .then(() =>
        this.setState({
          fetching: false,
          message: 'Password reset',
          error: '',
        }),
      )
      .then(() => this.props.onAfterSetPassword())
      .catch(err =>
        this.setState({
          fetching: false,
          formEnabled: true,
          message: '',
          error: err.message,
        }),
      );
  };

  render = () => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '5rem 6rem',
      }}
    >
      <div>
        <Brandmark />
      </div>
      <H3 style={{ marginTop: '3rem' }}>Set new password</H3>
      <P1 style={{ textAlign: 'center' }}>
        Check your email. We just sent you a code to
        reset&nbsp;your&nbsp;password.
      </P1>

      <Form onSubmit={this.onSubmit} enabled={this.state.formEnabled}>
        <Input
          name="email"
          type="email"
          value={this.state.email}
          onChange={value => this.setState({ email: value })}
        >
          YOUR EMAIL
        </Input>
        <Input
          name="code"
          type="text"
          value={this.state.code}
          onChange={value => this.setState({ code: value })}
        >
          YOUR VERIFICATION CODE
        </Input>
        <Input
          name="password"
          type="password"
          value={this.state.password}
          onChange={value => this.setState({ password: value })}
        >
          AND NEW PASSWORD
        </Input>
      </Form>

      <div
        style={{
          width: '100%',
          textAlign: 'left',
          color: Style.Colors.error,
        }}
      >
        <P1>
          {this.state.error ||
            this.props.error ||
            this.state.message || <span>&nbsp;</span>}
        </P1>
      </div>

      <Button
        type="submit"
        onClick={this.onSubmit}
        working={this.state.fetching}
        size="large"
      >
        Set New Password
      </Button>
    </div>
  );
}

export default props => {
  return (
    <PasswordReset>
      <ResetPasswordForm {...props} />
    </PasswordReset>
  );
};



// WEBPACK FOOTER //
// ./src/components/ResetPasswordForm/ResetPasswordForm.js